import {Component, OnInit} from '@angular/core';
import {MsalService} from "@azure/msal-angular";
import {Router} from "@angular/router";
import {AppState} from "../../../reducers/reducer";
import {Store} from "@ngrx/store";
import {Observable, Subject} from "rxjs";
import {environment} from "../../../../environments/environment";
import {UntypedFormBuilder, UntypedFormControl, FormGroup, Validators} from "@angular/forms";
import {getErrorMessage} from "../../selectors/auth.selector";
import {login} from "../../actions/auth.actions";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  env : string = "";
  loading = false;

  loginForm: any;
  error$: Observable<string | undefined> | undefined;
  private readonly onDestroy = new Subject<void>();

  constructor(
    private readonly msalService: MsalService,
    private router: Router,
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    // private readonly azureAdService: AzureAdService
  ) { }

  ngOnInit(): void {
    this.env = environment.ENVIRONMENT;

    this.error$ = this.store.select(getErrorMessage);

    this.loginForm = this.fb.group({
      username: new UntypedFormControl(null, [Validators.required]),
      password: new UntypedFormControl(null, [Validators.required]),
    })

    localStorage.clear();
    sessionStorage.clear();

    // const user = this.store.select(getUser);
    // console.log (user);
  }

  login() {
    this.loginForm.markAllAsTouched();
    if (this.loginForm.valid) {
      this.loading = true;
      this.store.dispatch(
        login({
          username: this.loginForm.value.username,
          password: this.loginForm.value.password,
        })
      );
    }
  }
}
